import {
  apiAddProduct,
  apiDeleteProduct,
  apiGetProduct,
  apiGetProducts,
  apiUpdateProduct,
} from "@lib/api/product";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useProductQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, enabled = true, messages } = props;
  const queryKeys = queryKey || [
    "product",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const productQuery = useQuery({
    queryFn: () => apiGetProduct(id),
    queryKey: queryKeys,
    enabled: !!id && !!enabled,
  });

  const productsQuery = useQuery({
    queryFn: () => apiGetProducts(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addProductMutation = useMutation({
    mutationFn: apiAddProduct,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.product"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateProductMutation = useMutation({
    mutationFn: apiUpdateProduct,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.product"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteProductMutation = useMutation({
    mutationFn: apiDeleteProduct,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.product"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    productQuery,
    productsQuery,
    addProductMutation,
    updateProductMutation,
    deleteProductMutation,
  };
};
